import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import IconPlus from 'cccisd-icons/plus-circle2';

import CareCoordinatorForm from 'js/components/CareCoordinatorForm';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;

const AddCareCoordinator = props => {
    const modal = useRef();
    const currentRole = Fortress.user && Fortress.user.acting.role.handle;
    const isSupervisor = currentRole === 'supervisor';
    // Also auto-fills the site for Site Admin.
    const isSiteAdmin = currentRole === 'siteAdmin';
    const hasFixedSite = isSupervisor || isSiteAdmin;

    const onSubmit = async values => {
        const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
            role: 'careCoordinator',
            firstName: values.firstName,
            first_name: values.firstName,
            lastName: values.lastName,
            last_name: values.lastName,
            email: values.email,
            adminId: values.adminId,
            phoneNumber: values.phoneNumber,
            enrolledInSmartwrap: values.enrolledInSmartwrap,
            administerPageAccess: values.administerPageAccess,
            dashboardPageAccess: values.dashboardPageAccess,
            managePageAccess: values.managePageAccess,
            receiveAlertsImmediately: values.receiveAlertsImmediately,
            receiveAlertsDigest: values.receiveAlertsDigest,
            receiveNotifications: values.receiveNotifications,
            supervisorReceiveAlertsImmediate: values.supervisorReceiveAlertsImmediate,
            supervisorReceiveAlertsDigest: values.supervisorReceiveAlertsDigest,
            supervisorReceiveNotifications: values.supervisorReceiveNotifications,
            exitDate: values.exitDate,
            exitReasonCareCoordinator: values.exitReasonCareCoordinator,
            group: values.site,
            ...(isSupervisor || values.enrolledInSmartwrap ? { parentPawns: values.supervisor } : {}),
            ...(values.existingUser ? { user: values.email } : { username: values.email }),
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ type: 'danger', message: errorMessage });
            return Promise.reject(response.data.errors);
        }

        await props.loadData();
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <IconPlus spaceRight />
                    Add Care Coordinator
                </button>
            }
            title="Add New Care Coordinator"
        >
            <CareCoordinatorForm
                onSubmit={onSubmit}
                isEdit={false}
                initialValues={{
                    firstName: '',
                    lastName: '',
                    email: '',
                    adminId: '',
                    phoneNumber: '',
                    enrolledInSmartwrap: false,
                    administerPageAccess: true,
                    dashboardPageAccess: true,
                    managePageAccess: true,
                    receiveAlertsImmediately: true,
                    receiveAlertsDigest: true,
                    receiveNotifications: true,
                    supervisorReceiveAlertsImmediate: false,
                    supervisorReceiveAlertsDigest: true,
                    supervisorReceiveNotifications: true,
                    exitDate: '',
                    exitReasonCareCoordinator: '',
                    site: hasFixedSite && Fortress?.user?.acting?.group?.id ? [Fortress.user.acting.group.id] : [],
                    supervisor: isSupervisor && Fortress?.user?.acting?.id ? Fortress.user.acting.id : '',
                }}
            />
        </Modal>
    );
};

AddCareCoordinator.propTypes = {
    loadData: PropTypes.func,
};

export default AddCareCoordinator;
